import PanelBoxLayout from 'components/layout/panelBox';
// import PaginationApp from "components/pagination";

// import * as T from "common/types";
import * as S from './styles';
import Gap from 'components/gap';
import convertToLocalTime from 'common/helpers/convertToLocalTime';
import { ReactSVG } from 'react-svg';
// import moment from 'moment';

const priorityMap = {
  '1': 'Critical',
  '2': 'High',
  '3': 'Moderate',
  '4': 'Low',
  '5': 'Planning'
};

const statusMap = {
  '1': 'New',
  '2': 'In Progress',
  '5': 'On Hold',
  '7': 'Canceled By Reqester',
  '4': 'Canceled By Approver',
  '3': 'Closed Completed'
};

interface IProps {
  data: any;
}

export default function TicketDetailInfo({ data }: IProps) {
  // const { ticketCloseRequestAction } = useActions();
  // const [showCloseModal, setShowCloseModal] = useState<boolean>(false);

  // const navigate = useNavigate();

  // const handleShowCloseTicket = () => {
  //   setShowCloseModal(true);
  // };

  // const handleHideCloseTicket = () => {
  //   setShowCloseModal(false);
  // };

  // const handleCloseTicket = () => {
  //   ticketCloseRequestAction(data.id, () => {
  //     handleHideCloseTicket();
  //     navigate('/panel/ticket/tickets');
  //   });
  // };

  function getLabelFromMap<T extends Record<string, string>>(map: T, key: string | number): string {
    const keyStr = key.toString();
    return map[keyStr] || '-';
  }

  return (
    <S.Content>
      <PanelBoxLayout style={{ padding: '20px 30px' }}>
        <Gap size="10px" />
        <S.Detail>
          <S.Item style={{ justifyContent: 'space-between', display: 'flex' }}>
            <div>
              <S.MainTitle>Requester</S.MainTitle>
              <S.Grid>
                <S.Icon src={data?.user?.profilePhoto || '/images/default-avatar.jpg'} />
                <S.Text>{data?.user?.name}</S.Text>
              </S.Grid>
            </div>
            <div>
              <S.Title>State</S.Title>
              <S.Text>{getLabelFromMap(statusMap, data?.state || '-')}</S.Text>
            </div>
          </S.Item>

          {/* <S.Item>
            <S.MainTitle>Requester</S.MainTitle>
            <S.Grid>
              <S.Icon src={data?.user?.profilePhoto || '/images/default-avatar.jpg'} />
              <S.Text>{data?.user?.name}</S.Text>
            </S.Grid>
          </S.Item> */}
          {/* <S.Item>
            <S.Title>Department</S.Title>
            <S.Text>Department</S.Text>
          </S.Item> */}
          <S.Item>
            <S.Title>Employee ID</S.Title>
            <S.Text>{data?.user?.sys_id || '-'}</S.Text>
          </S.Item>
          <S.Item>
            <S.Title>Subject</S.Title>
            <S.Text>{data?.short_description?.replace(/\r\n/g, '\n') || '-'}</S.Text>
          </S.Item>

          <S.Item>
            <S.Title>Email</S.Title>
            <S.Text>{data?.user?.email || '-'}</S.Text>
          </S.Item>
          <S.Item>
            <S.Title>Open Date</S.Title>
            {/* <S.Text>{moment(data?.opened_at).format('YYYY.MM.DD - HH:MM') || '-'}</S.Text> */}
            <S.Text>{convertToLocalTime(data?.sys_created_on).toLocaleString() || '-'}</S.Text>
          </S.Item>
          <S.Item>
            <S.Title>Number</S.Title>
            <S.Text>{data?.number || '-'}</S.Text>
          </S.Item>
          {/* <Gap size="15px" />
          <S.MainTitle>Ticket Details</S.MainTitle> */}
          {/* <S.Item>
            <S.Title>State</S.Title>
            <S.Text>{getLabelFromMap(statusMap, data?.state || '-')}</S.Text>
          </S.Item> */}
          <S.Item>
            <S.Title>Priority</S.Title>
            <S.Text>{getLabelFromMap(priorityMap, data?.priority || '-')}</S.Text>
          </S.Item>
          <S.Item>
            <S.Title>Ticket ID</S.Title>
            <S.Text>{data?.sys_id}</S.Text>
          </S.Item>
        </S.Detail>
        <div style={{ display: 'grid', gridTemplateColumns: 'auto', columnGap: 30 }}>
          {data?.variables
            ?.filter((r: any) => r.value)
            ?.map((item: any) => (
              <S.Item
                style={{ display: 'flex', justifyContent: 'space-between', paddingTop: 20, paddingBottom: 20, gap: 20 }}
              >
                <S.Title style={{ marginBottom: 0 }}>{item.label}</S.Title>
                <S.Text style={{ marginBottom: 0 }}>
                  {item.friendly_type === 'date_time' ? convertToLocalTime(item?.value).toLocaleString() : item.value}
                </S.Text>
              </S.Item>
            ))}
          {data?.attachments
            ?.filter((r: { isVariable: boolean }) => r.isVariable)
            .map((item: { label: string; value: { file_name: string; downloadUrl: string } }) => (
              <S.Item
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  paddingTop: 20,
                  paddingBottom: 20,
                  gap: 20
                }}
              >
                <S.Title style={{ marginBottom: 0 }}>{item.label}</S.Title>
                <a href={item?.value?.downloadUrl} style={{ marginBottom: 0 }} target="_blank" rel="noreferrer">
                  <ReactSVG
                    src="/icons/file-download.svg"
                    beforeInjection={(svg) => {
                      svg.setAttribute('width', `25px`);
                      svg.setAttribute('heigth', `25px`);
                    }}
                    wrapper="span"
                  />
                  {item?.value?.file_name}
                </a>
              </S.Item>
            ))}
        </div>

        {data?.attachments?.filter((r: { isVariable: boolean }) => !r.isVariable)?.length ? (
          <>
            <Gap size="40px" />
            <S.Head>Attachments</S.Head>

            <div style={{ display: 'grid', gridTemplateColumns: 'auto auto auto', columnGap: 30 }}>
              {data?.attachments
                ?.filter((r: { isVariable: boolean }) => !r.isVariable)
                .map((item: { label: string; value: { file_name: string; downloadUrl: string } }) => (
                  <S.Item
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      paddingTop: 20,
                      paddingBottom: 20,
                      gap: 20
                    }}
                  >
                    <a href={item?.value?.downloadUrl} style={{ marginBottom: 0 }} target="_blank" rel="noreferrer">
                      <ReactSVG
                        src="/icons/file-download.svg"
                        beforeInjection={(svg) => {
                          svg.setAttribute('width', `25px`);
                          svg.setAttribute('heigth', `25px`);
                        }}
                        wrapper="span"
                      />
                      {item?.value?.file_name}
                    </a>
                  </S.Item>
                ))}
            </div>
          </>
        ) : (
          <></>
        )}

        {/* <Gap size="20px" />
        <S.Div style={{ textAlign: 'right' }}>
          <DangerButton
            style={{
              background: "#DCF6F0",
              // color: "var(--primary-green)",
              fontSize: 14,
              fontWeight: 400,
              borderRadius: 8,
              height: 36,
              width: 208,
              marginLeft: 'auto'
            }}
            onClick={handleShowCloseTicket}
            disabled={data?.status === 'active' ? false : true}
          >
            {data?.status === 'active' ? 'Close Ticket' : 'Closed'}
          </DangerButton>
        </S.Div> */}
      </PanelBoxLayout>

      {/* <QuestionModal
        show={showCloseModal}
        handleClose={handleHideCloseTicket}
        model="delete"
        title="Close Ticket"
        text="Do you want to Close this Ticket?"
        handleSuccess={handleCloseTicket}
        successButtonText="Close"
      /> */}
    </S.Content>
  );
}
